// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__17csl","file":"styles_file__78eOB"};